<template>
    <div v-if="file">
        <ul
            role="list"
            class="border border-gray-200 rounded-md divide-y divide-gray-200"
        >
            <li
                class="pl-3 pr-4 py-3 flex items-center justify-between text-sm"
            >
                <div class="w-0 flex-1 flex items-center">
                    <IconPaperClip
                        class="flex-shrink-0 h-5 w-5 text-gray-400"
                    />
                    <span class="ml-2 flex-1 w-0 truncate">{{
                        file.name
                    }}</span>
                </div>
                <div class="ml-4">
                    <a
                        :href="`${baseUrl}/storage/download/${file.id}?token=${token}`"
                        :download="file.name"
                        class="pl-2 font-medium text-blue-600 hover:text-blue-500"
                    >
                        {{ $t('post.file_upload.download') }}
                    </a>
                </div>
            </li>
        </ul>
        <div
            v-if="isImage && !imgError"
            class="focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-blue-500 group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 overflow-hidden"
        >
            <img
                :alt="file.name"
                :src="`${baseUrl}/storage/${file.id}?token=${token}`"
                @error="imgError = true"
            />
        </div>
        <p v-else-if="isImage" class="mt-1 text-xs italic text-gray-400">
            {{ $t('post.page.attachment.preview_unavailable') }}
        </p>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import IconPaperClip from '@/components/icons/iconPaperClip.vue'

export default {
    name: 'PreviewUploadedFile',
    components: { IconPaperClip },
    props: ['file'],
    data() {
        return {
            baseUrl: this.$store.state.baseURL,
            token: this.$store.state.auth.token,
            imgError: false
        }
    },
    computed: {
        isImage() {
            const name = (this.file && this.file.name) || ''
            const ext = name.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        }
    }
}
</script>

<style scoped></style>
